import type { I18nConstants } from '../../types';

/**
 * Recursively flatten an I18nConstants value (string | string[] | object) -> string
 */
export function flattenI18n(raw: string | string[] | I18nConstants): string {
  if (typeof raw === 'string') {
    return raw;
  }

  if (Array.isArray(raw)) {
    return raw.join(' ');
  }

  // object case: flatten each value
  return Object.values(raw)
    .map(child => flattenI18n(child))
    .join(' ');
}
